import React from 'react';
import sortBy from 'lodash/sortBy';

import AppDashboard from '../AppDashboard'
import ListSessionTypesV2Screen from '../../components/availabilities/ListSessionTypesV2Screen';
import useUser from '../../hooks/useUser';
import {useGetSessionTypesQuery} from '../../redux/services/sessionTypeApi';

const ListSessionTypesV2Page = props => {
  const user = useUser();
  const providerId = user?.provider?.id;
  const sessionTypesQuery = useGetSessionTypesQuery(
    {provider_id: providerId, session_type_version: '2.0'},
    {skip: !providerId}
  );
  const childProps = {
    loading: sessionTypesQuery.isLoading || !user,
    sessionTypes: sortBy(
      (sessionTypesQuery?.data?.data || sessionTypesQuery.data || []),
      'id'
    ),
  };
  return (
    <AppDashboard 
      title='Session Types' 
      loading={childProps.loading}
      subtitle='Configure your service offerings with pricing and session details.'
    >
      <ListSessionTypesV2Screen {...childProps} />
    </AppDashboard>
  );

};

export default ListSessionTypesV2Page;